import { ClipLoader } from 'react-spinners';
import { theme } from 'styles/theme/theme';
import { UDButton, UDText } from 'ud-ui/components';
import { Body, Invitation, Processing } from './styles';

export interface DropzoneBodyProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  /** Идёт сжатие: вместо приглашения выбрать файл показываем, чем заняты. */
  isProcessing?: boolean;
}

/**
 * Содержимое зоны: приглашение выбрать файл или рассказ о том, что происходит.
 *
 * Про сжатие приходится говорить прямо: декодирование фотографии с телефона
 * занимает секунды, и раньше единственным признаком работы была полупрозрачная
 * зона — по ней невозможно отличить «идёт обработка» от «поле выключено».
 *
 * Приглашение при этом не убирается из разметки, а прячется: строка «Сжимаем
 * изображение…» ниже него, и подмена одного другим меняла бы высоту зоны —
 * страница дёргалась бы на каждый выбор файла и обратно.
 *
 * Заголовок печатается с переносами строк как есть: форма локаций подставляет
 * сюда двухстрочное объяснение про подписку.
 */
export function DropzoneBody(props: DropzoneBodyProps) {
  const { title = 'Перетащите сюда изображения', subtitle = 'или', buttonText = 'Выберите файл', onButtonClick, isProcessing } = props;

  return (
    <Body>
      <Invitation aria-hidden={isProcessing} className={isProcessing ? 'hidden' : undefined}>
        {title && (
          <UDText type="subhead" style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
            {title}
          </UDText>
        )}
        {subtitle && (
          <UDText type="subhead" color={theme.colors.SurfaceRomanSilver30}>
            {subtitle}
          </UDText>
        )}
        <UDButton variant="secondary" type="button" onClick={onButtonClick}>
          {buttonText}
        </UDButton>
      </Invitation>

      {isProcessing && (
        <Processing>
          <ClipLoader color="currentColor" size={20} />
          <UDText type="subhead" color={theme.colors.SurfaceRomanSilver30}>
            Сжимаем изображение…
          </UDText>
        </Processing>
      )}
    </Body>
  );
}
